// extracted by mini-css-extract-plugin
module.exports = {"Reviews-arrows--container":"PassSlidesArrows_Reviews-arrows--container__qxBNB"};